import merge from 'deepmerge';
import NewHomeSourcePartner from 'constants/partner';
import matchesMobileUserAgent from 'modules/deviceCapabilities';
import PageType from 'enums/pageType';
import UrlExtensions from 'utils/urlExtension';
import { selectUrlSubdirectory } from 'features/routing';
import selectTrackingCommonProperties from './redux/selectors';
import getAnalyticsTrackingProperties from './components/analyticsDataHandler';
import getAcxiomTrackingProperties from './components/acxiomDataHandler';

const businessInformationElement = document.querySelector("[data-component='business-information-data']");
const businessInformation = JSON.parse(businessInformationElement.innerHTML);

const getResponseVersion = (isMobileDevice) => (isMobileDevice ? 'M' : 'D');

/**
 * The getCommonPropertiesFromOtherSources function returns an object containing the properties obtained from:
 * sources such as html, or constants.
 * @return An object with the properties not stored in redux.
 */
const getCommonPropertiesFromOtherSources = (store) => {
  const urlSubdirectory = selectUrlSubdirectory(store) || UrlExtensions.getSubdirectory(window.location);
  const pageType = PageType.fromKey(urlSubdirectory)?.toString();
  const isMobileUserAgent = matchesMobileUserAgent();
  const acxiomTrackingProperties = getAcxiomTrackingProperties();
  const properties = {
    pageType,
    buildCodeVersion: businessInformation.buildCodeVersion,
    responseVersion: getResponseVersion(isMobileUserAgent),
    testVersion: NewHomeSourcePartner.testVersion,
    partnerId: NewHomeSourcePartner.partnerId,
    partnerName: NewHomeSourcePartner.partnerName,
    brandPartnerName: NewHomeSourcePartner.brandPartnerName,
    acxiomTrackingProperties
  };

  return properties;
};

/**
 * The function returns common tracking properties that are stored in the redux store.
 * @param store - The `store` parameter is likely an object representing a store or a state management
 * @returns an object containing the properties stored in a redux store.
 */
const getCommonPropertiesFromStore = (store) => {
  const trackingCommonPropertiesFromStore = selectTrackingCommonProperties(store);
  return trackingCommonPropertiesFromStore;
};

/**
 * The getTrackingCommonProperties function returns tracking common properties from the Redux store.
 * this uses a selector which takes from other features selectors a set of properties and combines them.
 * The idea is that this selector can be used for different tracking consumers such as segment, g4.
 * by a respective object builder which will filter that properties as needed.
 * @param store Access the redux store
 *
 * @return An object of properties.
 */
const getTrackingCommonProperties = (store) => {
  const trackingCommonPropertiesFromStore = getCommonPropertiesFromStore(store);
  const trackingCommonPropertiesFromOtherSources = getCommonPropertiesFromOtherSources(store);
  const trackingCommonProperties = merge(trackingCommonPropertiesFromStore, trackingCommonPropertiesFromOtherSources);
  return trackingCommonProperties;
};

export { getAnalyticsTrackingProperties };
export default getTrackingCommonProperties;